<template>
  <div v-if="showComponent" :id="id">
    <label
      :for="id + 'color-picker'"
      :title="label"
      class="text-truncate d-block"
      v-if="label"
      >{{label}}<small v-if="v.required !== undefined">*</small></label>
    <font-awesome-icon
      :id="id + 'font-awesome-icon-edit'"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      :id="id + 'font-awesome-icon-question-circle'"
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
      />
      <v-swatches
        :id="id + 'color-picker'"
        @input="$emit('input', $event)"
        :swatches="swatches"
        :shapes="shapes"
        :class="{'is-invalid': v.$error}"
        popover-y="bottom"
        :trigger-style="{  border: '3px solid #636363' }"
        v-model="valueData"
        v-bind="options"
        :show-fallback="showFallback"
        :fallback-input-type="fallbackInputType"
      />
    <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      // valueData: this.value
    }
  },
  computed: {
    valueData: {
      get () {
        return this.value || this.defaultValue
      },
      set (val) {}
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    shapes: {
      type: String,
      default: 'circles'
    },
    swatches: {
      type: Array | String,
      default: 'text-advanced'
    },
    showFallback: {
      type: Boolean,
      default: false
    },
    fallbackInputType: {
      type: String,
      default: 'color'
    },
    defaultValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VSwatches
  }
}
</script>
